/**
 * Shared Zod schema for Developer Registration forms
 * Used by DeveloperRegistrationForm, DeveloperRegistrationPage, DeveloperRegistrationPageUpdate
 */

import { z } from 'zod';

export const registrationSchema = z
  .object({
    companyName: z
      .string()
      .min(2, 'Company name must be at least 2 characters')
      .max(200, 'Company name cannot exceed 200 characters'),
    companyAddress: z
      .string()
      .min(10, 'Company address must be at least 10 characters')
      .max(500, 'Company address cannot exceed 500 characters'),
    ownerContactName: z
      .string()
      .min(2, 'Owner contact name must be at least 2 characters')
      .max(100, 'Owner contact name cannot exceed 100 characters'),
    ownerContactEmail: z
      .string()
      .email('Invalid email address format')
      .max(254, 'Email address cannot exceed 254 characters'),
    technicalContactName: z
      .string()
      .max(100, 'Technical contact name cannot exceed 100 characters')
      .optional()
      .or(z.literal('')),
    technicalContactEmail: z
      .string()
      .email('Invalid email address format')
      .max(254, 'Email address cannot exceed 254 characters')
      .optional()
      .or(z.literal('')),
    accessCode: z
      .string()
      .max(50, 'Access code cannot exceed 50 characters')
      .optional()
      .or(z.literal('')),
  })
  .refine(
    (data) => {
      if (data.technicalContactName && data.technicalContactName.trim() !== '') {
        return data.technicalContactEmail && data.technicalContactEmail.trim() !== '';
      }
      return true;
    },
    {
      message: 'Technical contact email is required when name is provided',
      path: ['technicalContactEmail'],
    }
  );

export type RegistrationFormValues = z.infer<typeof registrationSchema>;
